<template>
  <div class="original-bill">
    <div class="header">
      <el-input class="query" v-model.trim="billDate" placeholder="请输入对账账期" clearable @keyup.native.enter="getBillList(1)" @clear="getBillList(1)"></el-input>
      <el-button type="primary" @click="getBillList(1)">查询</el-button>
    </div>
    <Table ref="table" :data="billList" :columns="columns" :pages="pages"></Table>
  </div>
</template>
<script>
import BillService from "@/apis/BillService";
import Table from "@/components/new-table.vue";
export default {
  components: { Table },
  data() {
    return {
      billDate: "",
      billList: [],
      columns: [
        { label: "对账账期", prop: "billDate", "min-width": "90px" },
        {
          label: "差异记录", "min-width": "80px", render: (h, { row }) => {
            return <span class="diff-num" style={{ color: row.errorCount > 0 ? "#F56C6C" : "" }} onClick={() => { this.openDifference(row) }}>{row.errorCount}</span>
          }
        },
        { label: "当日营收", prop: "merchantRevenue", "min-width": "110px" },
        { label: "订单金额", prop: "payMoney", "min-width": "80px" },
        { label: "服务费", prop: "serviceFee", "min-width": "70px" },
        { label: "应对账金额", prop: "merchantPayMoney", "min-width": "110px" },
        { label: "实际对账金额", prop: "merchantIncome", "min-width": "110px" },
        { label: "退款金额", prop: "refundMoney", "min-width": "80px" },
        { label: "退款服务费", prop: "refundFee", "min-width": "100px" },
        { label: "退款应对账金额", prop: "merchantRefund", "min-width": "130px" },
        { label: "退款实际对账金额", prop: "merchantRefundBillMoney", "min-width": "140px" },
        { label: "创建时间", prop: "creationTime", "min-width": "150px"},
        {
          label: "操作", width: "90px", render: (h, { row }) => {
            return <div>
              <el-button type="text" onClick={() => { this.openStatementDay(row) }}>详情</el-button >
              <el-button type="text" v-show={row.errorCount > 0} onClick={() => { this.openDifference(row) }}>差异</el-button >
            </div>
          }
        },
      ],
      pages: {
        props: {
          total: 0,
          "page-size": 20,
          "current-page": 1,
        },
        on: {
          "current-change": this.currentChange,
          "size-change": this.sizesChange
        },
      },
    }
  },
  mounted() {
    this.getBillList();
  },
  beforeRouteUpdate(to, from, next) {
    console.log("aaa");
    next(vm => {
      vm.$refs.table.$refs.table.doLayout(); // 解决表格错位
    })
  },
  methods: {
    getBillList(pageIndex) {
      const page = pageIndex || this.pages.props["current-page"];
      const pageSize = this.pages.props["page-size"];
      BillService.getStatementList(page, pageSize, this.billDate).then(res => {
        this.billList = res.data.map(i => {
          i.serviceFee = (i.platformIncome + i.incomeServiceCharge).toFixed(2) //服务费=平台的结算金额+手续费
          i.refundFee = (i.platformRefundBillMoney + i.refundServiceCharge).toFixed(2) //服务费=平台的结算金额+手续费
          return i;
        });
        this.pages.props.total = res.dataCount;
      });
    },
    sizesChange(val) {
      this.pages.props["page-size"] = val;
      this.getBillList(1);
    },
    currentChange(page) {
      this.pages.props["current-page"] = page;
      this.getBillList();
    },
    openStatementDay({ id }) {
      this.$router.push({ path: "/statement-list", query: { id } })
    },
    openDifference({ billStatisticalId }) {
      this.$router.push({ path: "/statement-diff", query: { id: billStatisticalId } })
    },
  }
}
</script>

<style lang="scss" scoped>
.original-bill {
  display: flex;
  flex-direction: column;
}
.header {
  margin-bottom: 20px;
}
.query {
  width: 200px;
  margin-right: 20px;
  vertical-align: middle;
}
.state {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  .state-dot {
    width: 5px;
    margin-right: 5px;
    height: 5px;
    border-radius: 50%;
  }
}
</style>
<style>
.diff-num {
  display: inline-block;
  padding: 2px 6px;
  cursor: pointer;
}
</style>